import { colors } from '../../../utils/helpers/colors'

const HeaderLinkBoxButtonConfigs = {
  SelogerAdListPurchase: { hasArrow: false },
  SelogerAdListRent: { hasArrow: false },
  SelogerNeufAdList: { color: colors.framboise, hasArrow: true },
  SelogerConstruireAdList: { color: colors.fern, hasArrow: true },
  BellesdemeuresAdList: { color: colors.darkGrey, hasArrow: true },
}

export default HeaderLinkBoxButtonConfigs
